var _image;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgReportFile(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 34,
    height: 42,
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink"
  }, props), _image || (_image = /*#__PURE__*/React.createElement("image", {
    x: 82,
    y: 766,
    width: 34,
    height: 42,
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAEAAAABQCAYAAACpv3NFAAAABGdBTUEAALGOfPtRkwAAAidJREFUeAHtnEuOgzAMhmGEVKlSewd2CCS4/zW4QO9QEIhVZkxFRVMy4eGQh82mQIgfn//QkEXiSHOUZSk0jxhtrus6Nungy3hVVeL5fJr0udn24/H4inOzEUWHD8NpmlqttiLG8bYpCG8ALic/gTEB4QeMZ1nmbOWn5OHXRJFGAMMwzP04fY4NYQTgdMYLwWFCiIuiEF3XLbh53brdbso27AYhRNS27WqzGO+EWEcTw8nqjP4e1MUj2zoan5dDYA5hK7B5Xzj3HgAkcQRCEACOQAgGwF4IQQHYAyE4AFshBAlgC4RgAayFEDSANRCCB6CDQALAfxDIAFBBIAVgCQI5ADIEkgDmEMgCmCCQBgAQGABQoHwkriV/dI1Pzke3WsRDQCZG7ZoVQK3icr6sAJkItWtWALWKy/myAmQi1K7JKwDlW0A33zalKozvBvIKYACm5OmLXVaAL5UyFScrwBRZX+yizAMw/o9tAeMhYIu8K35ZAa5UwlYcrABb5F3xS14BKPMAXg9wRc874iA/BBjADtUE1YUVEFQ5dyRDXgEo8wBeD9ghPVe6kB8CDMAVKdqKgxVgi7wrfskrIM7zXPR9ryzImRsoKIM40NA0jbL39XqNxl1kbC1oKCM7qQEmcOSHwAggSVBmxCfVDcfN5XIZDXm1kRJO6i8r0/fLGwDcpvIumJKHnD/eAdAAb8ZQj/v9Hs2Thzw/FLCUOOwuB/v7+HrotuP7BQgoeKliBqTUAAAAAElFTkSuQmCC",
    transform: "translate(-82 -766)",
    fill: "none",
    fillRule: "evenodd"
  })));
}
export default __webpack_public_path__ + "img/beb61aa73ac0bc57bb82b4228e4dba39.svg";
export { SvgReportFile as ReactComponent };